import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ClassesState {
  formatadas: Record<string, string[]>;
}

const initialState: ClassesState = {
  formatadas: {},
};

const classesSlice = createSlice({
  name: 'classes',
  initialState,
  reducers: {
    setClassesFormatadas(state, action: PayloadAction<Record<string, string[]>>) {
      state.formatadas = action.payload;
    },
  },
});

export const { setClassesFormatadas } = classesSlice.actions;
export default classesSlice.reducer;
